import { t, type I18nLocale } from '@ardoq/i18n';

export type TranslatableWidgetError = {
  error?: string;
  errorMessageCode?: string;
  errorMessageData?: Record<string, string>;
};

/**
 * Resolve a widget's backend error to a translated string. Newer API
 * responses include `errorMessageCode` + `errorMessageData` so we can look
 * up a localized template under `apiErrors:<code>`. Older clients
 * (or unknown codes) fall back to the English `error` string.
 */
export const getTranslatedWidgetError = (
  widget: TranslatableWidgetError,
  i18nLocale: I18nLocale
): string | undefined => {
  const { error, errorMessageCode, errorMessageData } = widget;
  if (!errorMessageCode) return error;
  return t(
    i18nLocale,
    `apiErrors:${errorMessageCode}`,
    errorMessageData ?? {},
    error ?? ''
  );
};
